import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AppRoutesNames,
  AuthenticationRouteNames,
  OnSingUpGuard,
} from '@core/presentation';
import { RedirectOnAuthGuard } from '@geekbears/gb-ngrx-auth-basic';
import {
  SignUpPage,
  ChangeDefaultPasswordComponent,
  CompanyInformationComponent,
  ConfirmAccountComponent,
  ForgotPasswordComponent,
  IsBlockedComponent,
  LoginPage,
  NewPasswordComponent,
  PasswordCodeComponent,
  PersonalInformationComponent,
  PickAPlanComponent,
  OrganizationInformationComponent,
  AccountInformationComponent,
  SignupSelectionPage,
  JoinOrganizationPage,
  AdminSignUpPage,
  SignupInfoPage,
  ThankYouPage,
} from './pages';
import { RegisterComponent } from './pages/register/register.component';

const routes: Routes = [
  {
    path: AppRoutesNames.authentication,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: AuthenticationRouteNames.signIn,
      },

      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.signIn,
        component: LoginPage,
        canActivate: [RedirectOnAuthGuard],
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.forgotPassword,
        component: ForgotPasswordComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.passwordCode,
        component: PasswordCodeComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.personalInformation,
        component: PersonalInformationComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.newPassword,
        component: NewPasswordComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.isBlocked,
        component: IsBlockedComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.confirmAccount,
        component: ConfirmAccountComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.changeDefaultPassword,
        component: ChangeDefaultPasswordComponent,
        canActivate: [OnSingUpGuard],
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.basicInfo,
        redirectTo: AuthenticationRouteNames.signUp,
        // canActivate: [OnSingUpGuard],
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.signUp,
        component: SignupSelectionPage,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.adminSignUp,
        component: AdminSignUpPage,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.joinOrganization,
        component: JoinOrganizationPage,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.adminInfo,
        component: SignupInfoPage,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.employeeInfo,
        component: SignupInfoPage,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.thankYou,
        component: ThankYouPage,
      },

 {
        pathMatch: 'full',
        path: AuthenticationRouteNames.register,
        component: RegisterComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.organizationInformation,
        component: OrganizationInformationComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.accountInformation,
        component: AccountInformationComponent,
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.companyInformation,
        component: CompanyInformationComponent,
        canActivate: [OnSingUpGuard],
      },
      {
        pathMatch: 'full',
        path: AuthenticationRouteNames.pickPlan,
        component: PickAPlanComponent,
        canActivate: [OnSingUpGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
